// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__sPo+J","img":"Image_img__+ZEtJ","skeleton":"Image_skeleton__zvRfb"};